import { InfoCircledIcon } from '@/components/icons';
import { Callout, Flex } from '@radix-ui/themes';

export default function ErrorCallout({ show, text, errors }) {
  if (!show) return;

  return (
    <Callout.Root color="red">
      <Callout.Icon>
        <InfoCircledIcon />
      </Callout.Icon>
      <Callout.Text>{text}</Callout.Text>
      {errors && (
        <Flex direction="column" gap="2">
          <ul className="list-disc text-sm">
            {Object.values(errors).map((error) => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Flex>
      )}
    </Callout.Root>
  );
}
